import React from 'react'
import { FiChevronRight } from 'react-icons/fi' 
import Slider from "react-slick";
import { defaultSettings, featuredPosts } from './mock';
 
export const Featured = () => {

    require('slick-carousel/slick/slick.css')
    require('slick-carousel/slick/slick-theme.css')
   
    return (
        <div className='featured'>
            <div className="flex">
                <h1 className='title'>Featured Projects</h1>
                <div>
                    <a href="##">See All <FiChevronRight/></a>
                </div>
            </div>
            <div className="">
                <div className=" carousel">
                    <Slider
                        className="featured-slider"
                        {...defaultSettings}
                    >
                        {featuredPosts?.map((item,i)=>(
                            <a href="##" target="_blank" className='image' key={'featured-images-'+i} >
                                <img src={`/assets/images/dummy/${item.img}.png`} className='cover' alt="" />
                                <div className="detail flex">
                                    <img src={`/assets/images/faces/${item.user?.avatar}.png`} className='avatar' alt="" />
                                    <div className="name"> <p>{item.user?.name}</p> </div>
                                </div>
                            </a>
                        ))}
                    </Slider>
                  
                </div>  
            </div>  

        </div>
    )
}